import { Box, SolidAnchorButton } from '@99designs/ui';
import { colors, typography } from '@99designs/ui/settings';
import { linkTo, Source } from '@99designs/feature-auth';
import { BaseLink } from '@99designs/purgatory';
import { FormattedReactMessage } from '@99designs/frontend-components/i18n';
import React from 'react';
import { OAuthProvider } from '@99designs/apps/spa/pages/auth/types';
import { useAuthConfigContext } from '@99designs/apps/spa/pages/auth/AuthConfigContext';
import { formatMessage } from '@99designs/frontend-components/i18n/index';
import { VistaprintLogomark } from '@99designs/icons';
import styled from 'styled-components';

export interface OAuthContinueButtonProps {
    target?: string | null;
    provider: OAuthProvider;
    source?: Source;
    action: 'login' | 'signup';
}

const providerIcon = (provider: OAuthProvider) => {
    switch (provider) {
        case 'Vistaprint':
            return <VistaprintLogomark />;
        default:
            return null;
    }
};

const PuntRoadSubtleText = styled.small`
    color: ${colors.puntRoad};
    font-size: ${typography.typeScale.size2}px;
`;

const OAuthContinueButtonMessage = {
    login: __('Log in with {provider}'),
    signup: __('Sign up with {provider}'),
};

export default function OAuthContinueButton({
    target = null,
    provider,
    source,
    action,
}: OAuthContinueButtonProps) {
    const { locale } = useAuthConfigContext();

    return (
        <>
            <SolidAnchorButton
                href={linkTo.authOAuthRedirect(provider, target, source)}
                data-testid="oauth-button"
                size="large"
                variant="secondary"
                width="fill"
                icon={providerIcon(provider)}
            >
                {formatMessage(OAuthContinueButtonMessage[action], {
                    provider: provider,
                })}
            </SolidAnchorButton>
            {provider == 'Vistaprint' && (
                <Box paddingTop="space8">
                    <PuntRoadSubtleText>
                        <FormattedReactMessage
                            message={__(
                                'We will automatically add your name and email to your 99designs account. <Link>Privacy Policy</Link>'
                            )}
                            replacements={{
                                Link: (
                                    <BaseLink
                                        href={
                                            locale == 'en-US'
                                                ? linkTo.vistaprintPrivacyPolicyUS()
                                                : linkTo.vistaprintPrivacyPolicy(locale)
                                        }
                                        size="subtle"
                                    />
                                ),
                            }}
                        />
                    </PuntRoadSubtleText>
                </Box>
            )}
        </>
    );
}
